module.exports = __webpack_public_path__ + "img/คาสิโนออนไลน์-บาคาร่าสด-รูเล็ต-ซิคโบ-ไฮโล-เสือ-มังกร.9701edbb.png";